import type { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';

export const ensureProperty = <T>(host: ChemistryLitElement, property: T | undefined): NonNullable<T> => {
  if (property) return property;
  throw new Error(`Property is missing in component: '${host.tagName}'`);
};
